export default "__VITE_ASSET__BAHXzV2h__"